// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PageContent{display:flex;flex-direction:column;flex-grow:1}@media (min-width: 1024px){.PageContent{padding-left:100px}}.PageContent_withPaddings{padding-top:80px;padding-left:15px;padding-right:15px}@media (min-width: 768px){.PageContent_withPaddings{padding-top:100px;padding-left:40px;padding-right:40px}}@media (min-width: 1024px){.PageContent_withPaddings{padding:120px 50px 100px 150px}}\n", ""]);
// Exports
module.exports = exports;
